<template lang="html">
  <root class="admin-cities">

    <admin-nav></admin-nav>
    <page-header name="Cities" :count="citiesCount"></page-header>

    <!-- Data -->
    <div class="container">

      <!-- Add new -->
      <div class="row">
        <div class="col m2 offset-m5">
          <router-link :to="{ name: 'CityAdd' }" class="waves-effect waves-light btn">Add</router-link>
        </div>
      </div>

      <table class="striped centered" v-if="cities.length">
        <thead>
          <tr>
            <th>City (EN)</th>
            <th>City (AR)</th>
            <th>Country</th>
            <th>Edit</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="city in cities">
            <td>{{ city.name.en }}</td>
            <td>{{ city.name.ar }}</td>
            <td class="uppercase">{{ city.country }}</td>
            <td class="edit" @click="cityEditRouter(city)"><i class="material-icons">mode_edit</i></td>
          </tr>
        </tbody>
      </table>
    </div>

    <preloader :is-active="!cities.length"></preloader>

  </root>
</template>

<script>
import * as firebase from 'firebase'
import pageState from '../../plugins/page-state'

export default {
  data: () => {
    return {
      citiesCount: 0,
      cities: [],
    }
  },

  methods: {

    // Collect
    collectCities() {
      firebase.database()
        .ref('countries')
        .once('value')
        .then( countriesSnap => {
          let countriesLoop = countriesSnap.numChildren()

          // Country
          countriesSnap.forEach( countrySnap => {
            countriesLoop--

            // Cities
            let citiesSnap = countrySnap.child('cities')
            let citiesLoop = citiesSnap.numChildren()

            citiesSnap.forEach( citySnap => {

              // City data
              let city = []
              city['key'] = citySnap.key
              city['name'] = citySnap.val().name
              city['country'] = countrySnap.key

              // Push
              this.cities.push(city)
              this.citiesCount++

              // Loop end
              citiesLoop--
              if (!countriesLoop && !citiesLoop) {
                setTimeout(() => {
                  var table = $('table').DataTable()
                  pageState.filtersBackup(this.$router.currentRoute, table)
                  pageState.restore(this.$router.currentRoute)
                }, 1000)
              }

            })

          })
        })
    },

    // City edit
    cityEditRouter(city) {
      let params = {
        countryKey: city.country,
        cityKey: city.key
      }

      this.$router.push({ name: 'CityEdit', params })
    }
  },

  beforeRouteLeave(to, from, next) {
    pageState.backup(next, this.$router.currentRoute)
  },

  // Mounted
  mounted() {
    this.collectCities()
  }
}
</script>

<style lang="scss">
@import '../../theme';

table {
  .edit:hover {
    color: $theme-color;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Cities.vue